import React from "react";

export const ServicesSection: React.FC = () => {
  return (
    <>
        <section id="services" className="services-section ftco-section">
            <div className="container">
                <div className="row justify-content-center pb-3">
                <div className="col-md-7 heading-section text-center">
                    <span className="subheading">usluge</span>
                    <h2 className="mb-4" style={{ color: 'black' }}>pregled usluga</h2>
                    <p style={{ fontSize: '20px' }}>
                        Pronađite savršenu uslugu za svoj stil i uživajte u vrhunskoj nezi i profesionalnom pristupu.
                    </p>
                </div>
                </div> 
                <div className="row">
                <div className="col-md-4 d-flex" style={{ justifyContent: 'center' }}>
                    <div className="media block-6 services d-block text-center">
                    <div className="icon d-flex justify-content-center align-items-center">
                    <img src="/images/icon1.png" alt="Image" width={'80px'} />
                    </div>
                    <div className="media-body">
                        <h3 className="heading mb-3" style={{ fontSize: '20px', marginTop: '10px' }}>Šišanje</h3>
                        <p style={{ fontSize: '18px'}}>
                            Prepustite se rukama iskusnih frizera i osvežite svoj izgled modernim šišanjem prema vašim željama.
                        </p>
                    </div>
                    </div>
                </div>
                <div className="col-md-4 d-flex" style={{ justifyContent: 'center' }}>
                    <div className="media block-6 services d-block text-center">
                    <div className="icon d-flex justify-content-center align-items-center">
                        <img src="/images/icon2.png" alt="Image" width={'80px'} />
                    </div>
                    <div className="media-body">
                        <h3 className="heading mb-3" style={{ fontSize: '20px', marginTop: '10px' }}>Stilizovanje brade</h3>
                        <p style={{ fontSize: '18px'}}>
                            Istaknite svoj stil uz precizno oblikovanje i stilizovanje brade – savršeno za svaku priliku.
                        </p>
                    </div>
                    </div>
                </div>
                <div className="col-md-4 d-flex" style={{ justifyContent: 'center' }}>
                    <div className="media block-6 services d-block text-center">
                    <div className="icon d-flex justify-content-center align-items-center">
                        <img src="/images/icon3.png" alt="Image" width={'80px'} />
                    </div>
                    <div className="media-body">
                        <h3 className="heading mb-3" style={{ fontSize: '20px', marginTop: '10px' }}>Šišanje i stilizovanje brade</h3>
                        <p style={{ fontSize: '18px'}}>
                            Za potpuni tretman, uživajte u kombinaciji šišanja i stilizovanja brade, prilagođeno vašim potrebama.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </section>
    </>     
  );
};
